module.exports = {
  scopes: {
    COACH: "Coach",
    PLAYER: "Player",
    SUPERADMIN: "SuperAdmin",
    PARKOWNER: "ParkOwner",
  },
};
